import { render } from "./BackComponent.vue?vue&type=template&id=0d4b4cb5&scoped=true"
import script from "./BackComponent.vue?vue&type=script&lang=js"
export * from "./BackComponent.vue?vue&type=script&lang=js"

import "./BackComponent.vue?vue&type=style&index=0&id=0d4b4cb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4b4cb5"]])

export default __exports__